export default __webpack_public_path__ + "static/warrior_2-48debf3fec3d4efcbdb0f063a9df047a.jpg";